/**
 * Application configuration using Vite environment variables.
 * These values are baked in at build time.
 *
 * To add a new env variable:
 * 1. Add it to your .env file with VITE_ prefix (e.g., VITE_MY_VAR)
 * 2. Add it here as config.myVar = import.meta.env.VITE_MY_VAR
 */
export const config = {
  API_HOST: import.meta.env.VITE_API_HOST as string,
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL as string,
  VAPID_PUBLIC_KEY: import.meta.env.VITE_VAPID_PUBLIC_KEY as string,
  GOOGLE_OAUTH_URL: import.meta.env.VITE_GOOGLE_OAUTH_URL as string,
  DISCORD_OAUTH_URL: import.meta.env.VITE_DISCORD_OAUTH_URL as string,
  TWITCH_OAUTH_URL: import.meta.env.VITE_TWITCH_OAUTH_URL as string,
  SURVIVAL_GAME_INITIAL_SECONDS: import.meta.env
    .VITE_SURVIVAL_GAME_INITIAL_SECONDS as string,
  MERCURE_URL: import.meta.env.VITE_MERCURE_URL as string
};

/**
 * Get the full API URL.
 */
export function getApiUrl(): string {
  return `${config.API_HOST}${config.API_BASE_URL}`;
}
